(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/fp/merge', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/fp/merge'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.merge, global.convert);
    global.merge = mod.exports;
  }
})(this, function (exports, _merge2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.merge = undefined;

  var _merge3 = _interopRequireDefault(_merge2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces by an object deeply merging own enumerable string keyed properties of source objects to the former object.<br />
   * Source objects are applied from left to right. Subsequent sources overwrite properties of previous sources.
   * @function
   * @memberof object
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {...Object} [sources] The source objects.
   * @return {Object} Returns the updated object.
   * @example merge({ nested: { prop: { a: 1 } } }, 'nested', { prop: { a: 2, b: 3 } }) // => { nested: { prop: { a: 2, b: 3 } } }
   * @see {@link https://lodash.com/docs#merge|lodash.merge} for more information.
   * @since 0.3.0
   */
  var merge = (0, _convert.convertLodashFp)(_merge3.default);
  exports.merge = merge;
  exports.default = merge;
});